import LandingButton from './LandingButton';

export default LandingButton;
